export enum Viewport {
  desktop = 'desktop',
  handheld = 'handheld',
  tablet = 'tablet',
  handset = "handset",
};
